import React from 'react';
import { Plugins } from '@leverege/plugin';
import AttributeForm from "./AttributeForm.js";
const AttributeFormFactory = Plugins.createFactory('AttributeForm', {
  strategy: Plugins.reactStrategy(React),
  pluginKey: 'form',
  typeKey: 'objectType',
  defaultObject: AttributeForm
});
export default AttributeFormFactory;